import React from 'react';
import { useAuth } from '../AuthContext';
import './DashboardHeader.css';

const DashboardHeader = () => {
  const { logout } = useAuth();
  
  return (
    <header className="dashboard-header">
      <div className="logo-container">
        <img 
          src="https://amicredit.ro/wp-content/uploads/2024/02/amicredit.svg" 
          alt="AmicCredit" 
          className="dashboard-logo"
          onError={(e) => {
            // Fallback if logo image doesn't exist
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        <div className="logo-text" style={{ display: 'none' }}>
          <span className="logo-ami">Ami</span>
          <span className="logo-credit">Credit</span>
        </div>
      </div>
      <button
        onClick={logout}
        aria-label="Log out"
        className="logout-btn"
      >
        Log out
      </button>
    </header>
  );
};

export default DashboardHeader;
